import { METHOD_NAME_APPLE_H2H } from '@/util/constants/cashbox'
import { storageService } from '~/services'

function normalize_depositPayments(payment) {
  return {
    ...payment,
    isH2h: !!payment?.input?.account_data,
  }
}

export const state = () => ({
  // Deposit
  depositPayments: [],
  depositPaymentsIframe: [],
  userMethodPayinExt: {},
  cardStatus: {},
  regexpForCard: '',
  cardIframeUrl: '',

  //Withdrawal
  withdrawalPayments: [],
  withdrawalBonuses: {},
  withdrawalPaymentsRegexp: '',
  userPayOut: {},
  cancelPayOut: {},
  payoutCommission: {},
  withdrawalInn: true,
  withdrawStatusCard: null,
  payoutData: null,
  withdrawalLoadingCommissionCardBonuses: false,

  //History
  historyTotalCount: 0,
  historyListFromFetch: [],
  isFetchingHistory: true,

  //All
  companyList: [],
  paymentsMessage: {},
  isFetchingPayments: true,
  isShowCloseCashboxModal: false,

  //Cards
  cardList: [],
  isShowCards: false,
  activeCard: {},
})
export const mutations = {
  // Deposit
  SET_PAYMENTS_DEPOSIT: (state, depositPayments) => {
    if (window?.ApplePaySession && ApplePaySession?.canMakePayments()) {
      state.depositPayments = depositPayments
    }
    else {
      state.depositPayments = depositPayments.filter(item => item.name !== METHOD_NAME_APPLE_H2H)
    }

    state.depositPaymentsIframe = depositPayments.filter(item => item?.in_game_modal_supported) || []

  },
  SET_USER_METHOD_PAYIN_EXT: (state, { testPayment }) => {
    state.userMethodPayinExt = testPayment
  },
  SET_CARD_STATUS: (state, { cardStatus }) => {
    state.cardStatus = cardStatus
  },
  SET_REGEXP_FOR_CARD: (state, { regexpForCard }) => {
    state.regexpForCard = regexpForCard
  },
  set_cardIframeUrl(state, url) {
    state.cardIframeUrl = url
  },

  //Withdrawal
  SET_PAYMENTS_WITHDRAWAL: (state, withdrawalPayments) => {
    state.withdrawalPayments = withdrawalPayments
  },
  SET_PAYMENTS_WITHDRAWAL_REGEXP: (state, regexp) => {
    state.withdrawalPaymentsRegexp = regexp
  },
  SET_USER_PAYOUT: (state, { userPayOut }) => {
    state.userPayOut = userPayOut
  },
  SET_CANCEL_PAYOUT: (state, { cancelPayOut }) => {
    state.cancelPayOut = cancelPayOut
  },
  SET_WITHDRAWAL_BONUSES: (state,  data ) => {
    state.withdrawalBonuses = data
  },
  setPayoutData(state, payload) {
    state.payoutData = payload
  },
  setPayoutCommission: (state, { data, amount }) => {
    data.amount = amount
    state.payoutCommission = data
  },
  setWithdrawalInn: (state, { data } ) => {
    state.withdrawalInn = data.status
  },
  setWithdrawStatusCard (state, data) {
    state.withdrawStatusCard = data
  },
  toogle_withdrawalLoadingCommissionCardBonuses: (state, { status }) => {
    state.withdrawalLoadingCommissionCardBonuses = status
  },

  //History
  setHistory: (state, data) => {
    state.historyTotalCount = data.total_count
    state.historyListFromFetch = data.data
  },
  setIsFetchingHistory: (state, payload) => {
    state.isFetchingHistory = payload
  },

  //All
  SET_PAYMENTS_COMPANY_LIST: (state, companyList) => {
    state.companyList = companyList
  },
  setIsFetchingPayments: (state, payload) => {
    state.isFetchingPayments = payload
  },
  SET_PAYMENTS_MESSAGE: (state, payload) => {
    state.paymentsMessage = payload
  },
  set_isShowCloseCashboxModal: (state, status) => {
    state.isShowCloseCashboxModal = status
  },

  // Cards
  set_cardList: (state, payload) => {
    if (payload.length === 0) {
      state.cardList = payload
      state.activeCard = {}
      return
    }

    const selectedCardId = storageService.getItem('selectCardId')

    if (selectedCardId) {
      const index = payload.findIndex(card => card.id === +selectedCardId)

      if (index > -1) {
        const [selectedCard] = payload.splice(index, 1)
        payload.unshift(selectedCard)
        state.cardList = payload
        state.activeCard = selectedCard
        return
      }
    }

    state.cardList = payload
    state.activeCard = payload[0]
    
  },
  set_selectCard: (state, id) => {
    const index = state.cardList.findIndex(card => card.id === id)
    if (index > -1) {
      const [selectedCard] = state.cardList.splice(index, 1)
      state.activeCard = selectedCard
      state.cardList.unshift(selectedCard)
      storageService.setItem('selectCardId', id)
    }
  },
  set_toggleIsShowCards: (state, payload) => {
    state.isShowCards = payload
  },
}
export const actions = {
  // Deposit
  LOAD_PAYMENTS_DEPOSIT: async function ({ commit }) {
    try {
      commit('setIsFetchingPayments', true)
      const res = await this.$api.deposit.getPaymentsDeposit()
      commit('SET_PAYMENTS_DEPOSIT', res?.data.list || [])
      commit('SET_PAYMENTS_COMPANY_LIST', res?.data.pay_company_list || [])
      commit('SET_PAYMENTS_MESSAGE', res?.data.message || {})
      commit('SET_REGEXP_FOR_CARD', { regexpForCard: res.data.regexp })
    }
    catch (error) {
      console.log('LOAD_PAYMENTS_DEPOSIT: ', error)
    }
    finally {
      commit('setIsFetchingPayments', false)
    }
  },
  USER_METHOD_PAYIN_EXT: async function ({ commit }, data) {
    try {
      const res = await this.$api.deposit.methodDepositExt(data)
      commit('SET_USER_METHOD_PAYIN_EXT', { testPayment: res.data })
      // TODO: не подобається треба фікс
      return res
    }
    catch (error) {}
  },
  CARD_STATUS: async function ({ commit }, uuid) {
    try {
      const res = await this.$api.deposit.depositCardStatus(uuid)
      commit('SET_CARD_STATUS', { cardStatus: res.data })
    }
    catch (error) {
      console.log(error)
    }
  },
  async sendPay(_, { amount = 0 }) {
    try {
      const request = {
        countryCode: 'UA',
        currencyCode: 'UAH',
        total: {
          label: 'Депозит',
          amount,
        },
        supportedNetworks: ['visa', 'masterCard', 'amex'],
        merchantCapabilities: ['supports3DS', 'supportsCredit'],
      }

      const session = new ApplePaySession(3, request)
      let pmntId = null

      session.onvalidatemerchant = (event) => {
        const validationURL = event.validationURL

        this.$api.apple_pay.applePayValidation({ amount, validationURL })
          .then(({ data }) => {
            if (!data.status) {
              session.abort()
              return
            }

            session.completeMerchantValidation(data.validation_data)
            pmntId = data.id
          })
          .catch(err => {
            console.warn(err)
            session.abort()
          })
      }

      session.onpaymentauthorized = (event) => {
        this.$api.apple_pay.applePayPay({ pmntId, tokenData: event.payment })
          .then(({ data }) => {
            const status = data.status ? ApplePaySession.STATUS_SUCCESS : ApplePaySession.STATUS_FAILURE
            session.completePayment(status)

            if (data.url) {
              setTimeout(() => {
                window.location.href = data.url
              }, 1500)
            }
          })
          .catch(err => {
            console.warn(err)
            session.completePayment(ApplePaySession.STATUS_FAILURE)
          })
      }

      session.begin()
    }
    catch (err) {
      console.log(err)
    }
  },
  async actGet_cardIframeUrl({ commit, rootGetters }) {
    try {
      const get_theme = rootGetters['base/get_theme']
      const { data } = await this.$api.deposit.getCardIframeUrl()
      if (!data || !data.status) {
        console.warn('getCardIframeUrl failed')
        return
      }
      const query = new URLSearchParams({ theme: get_theme.theme })
      commit('set_cardIframeUrl', `${data.url}?${query.toString()}` )
    }
    catch (err) {
      console.warn('getCardIframeUrl failed ', err)
    }
  },

  //Withdrawal
  LOAD_PAYMENTS_WITHDRAWAL: async function ({ commit }) {
    try {
      commit('setIsFetchingPayments', true)
      const res = await this.$api.withdrawal.getPaymentsWithdrawal()
      commit('SET_PAYMENTS_WITHDRAWAL', res?.data || [])
      commit('SET_PAYMENTS_WITHDRAWAL_REGEXP', res?.data.regexp)
    }
    catch (error) {
      console.log('LOAD_PAYMENTS_WITHDRAWAL: ', err)
    }
    finally {
      commit('setIsFetchingPayments', false)
    }
  },
  LOAD_PAYMENTS_BONUSES: async function ({ commit }) {
    const res = await this.$api.withdrawal.withdrawalBonuses()
    commit('SET_WITHDRAWAL_BONUSES', res?.data )
  },
  USER_PAYOUT: async function ({ commit }, data) {
    try {
      const res = await this.$api.withdrawal.withdrawal(data)
      commit('SET_USER_PAYOUT', { userPayOut: res.data })
      if (res.data?.payout_id) {
        storageService.setItem('payOutId', res.data?.payout_id)
      }
    }
    catch (e) {
      confirm(e, 'Сервер не отвечает')
      // window.location.reload();
    }
  },
  CANCEL_PAYOUT: async function ({ commit }, data) {
    try {
      const res = await this.$api.withdrawal.cancelWithdrawal(data)
      commit('SET_CANCEL_PAYOUT', { cancelPayOut: res.data })
    }
    catch (e) {
      confirm(e, 'Сервер не отвечает')
    }
  },
  payoutCommission: async function ({ commit }, amount) {
    const res = await this.$api.commission.withdrawalCommission(amount)
    commit('setPayoutCommission', { data: res.data, amount })
  },
  withdrawalInn: async function ({ commit }) {
    const res = await this.$api.withdrawal.withdrawalInn()
    commit('setWithdrawalInn', { data: res.data })
  },
  withdrawalCard: async function ({ commit }, data)  {
    const res = await this.$api.withdrawal.withdrawalCard(data)
    commit('setWithdrawStatusCard', res.data)
  },

  //History
  async fetchCashboxHistory({ commit }, params) {
    try {
      commit('setIsFetchingHistory', true)
      const res = await this.$api.cashboxHistory.payHistory(params)
      commit('setHistory', res?.data || { historyTotalCount: 0, historyList: [] })
    }
    catch (err) {
      console.log('newCashboxHistory/list: ', err)
    }
    finally {
      commit('setIsFetchingHistory', false)
    }
  },

  // Cards
  async fetch_cardList({ commit }) {
    try {
      const { data } = await this.$api.userRequisites.getCardList()
      commit('set_cardList', Array.isArray(data.requisites) ? data.requisites : [])
    }
    catch (err) {
      console.log('fetch cardList', err)
    }
  },
  act_selectCard({ commit }, id) {
    commit('set_selectCard', id)
  },
  toggleIsShowCards({ commit }, { status }) {
    commit('set_toggleIsShowCards', status)
  },
  async act_removeCard({ commit }, id) {
    try {
      const { data } = await this.$api.userRequisites.userRemoveCard(id)
      return data.success
    }
    catch (err) {
      console.log('fetch cardList', err)
    }
  },

  //ALL
  toggleIsShowCloseCashboxModal({ commit }, { status }) {
    commit('set_isShowCloseCashboxModal', status)
  },
}

export const getters = {
  // Deposit
  GET_CARD_STATUS: state => state.cardStatus,
  getDepositPaymentsRegexp: state => state.regexpForCard,
  get_userMethodPayinExt: state => state.userMethodPayinExt,
  get_cardIframeUrl: state => state.cardIframeUrl,
  get_depositPayments: state => state.depositPayments.map(normalize_depositPayments),
  get_depositPaymentsIframe: state => state.depositPaymentsIframe.map(normalize_depositPayments),

  //Withdrawal
  getPayoutCommission: state => state.payoutCommission,
  getWithdrawalPayments: state => state.withdrawalPayments,
  getWithdrawalPaymentsRegexp: state => state.withdrawalPaymentsRegexp,
  getWithdrawalBonuses: state => state.withdrawalBonuses,
  getWithdrawalInn: state => state.withdrawalInn,
  getWithdrawStatusCard: state => state.withdrawStatusCard,
  getUserPayOut: state => state.userPayOut,
  getPayoutData: state => state.payoutData,
  get_cancelWithdrawalData: (state) => state.cancelPayOut,
  get_withdrawalLoadingCommissionCardBonuses: (state) => state.withdrawalLoadingCommissionCardBonuses,

  get_isLoading: state => state.isFetchingPayments,

  //History
  get_historyTotalCount: (state) => state.historyTotalCount,
  get_historyListFromFetch: (state) => state.historyListFromFetch,
  get_isFetchingHistory: (state) => state.isFetchingHistory,

  // Cards
  get_cardList: (state) => state.cardList,
  get_activeCard: (state) => state.activeCard,
  get_isShowCards: (state) => state.isShowCards,

  //all
  get_isShowCloseCashboxModal: (state) => state.isShowCloseCashboxModal,
}
